import { usePostHog } from "posthog-js/react";
import { useRef } from "react";

export function useTrackViewedPhrases() {
  const posthog = usePostHog();
  const once = useRef(false);

  const trackViewedPhrases = () => {
    if (once.current) return;
    once.current = true;
    posthog.capture("viewed_phrases");
  };

  return trackViewedPhrases;
}